export var AsidVersion = /*#__PURE__*/ function(AsidVersion) {
    AsidVersion["V3"] = "V3";
    AsidVersion["V4"] = "V4";
    return AsidVersion;
}({});
export var SecurityError = /*#__PURE__*/ function(SecurityError) {
    SecurityError[SecurityError["NO_ISSUE"] = 0] = "NO_ISSUE";
    SecurityError[SecurityError["IMAGE_HASH_FAIL"] = 1] = "IMAGE_HASH_FAIL";
    SecurityError[SecurityError["SIGNATURE_MISMATCH"] = 2] = "SIGNATURE_MISMATCH";
    SecurityError[SecurityError["TIMING_ISSUE"] = 3] = "TIMING_ISSUE";
    SecurityError[SecurityError["SERVER_TIMEOUT"] = 4] = "SERVER_TIMEOUT";
    SecurityError[SecurityError["COULD_NOT_CONNECT"] = 5] = "COULD_NOT_CONNECT";
    SecurityError[SecurityError["TERMINATE_REQUESTED"] = 6] = "TERMINATE_REQUESTED";
    SecurityError[SecurityError["INVALID_REQUEST"] = 7] = "INVALID_REQUEST";
    SecurityError[SecurityError["INVALID_RESPONSE"] = 8] = "INVALID_RESPONSE";
    SecurityError[SecurityError["UNEXPECTED_RESPONSE"] = 9] = "UNEXPECTED_RESPONSE";
    SecurityError[SecurityError["INVALID_TOKEN"] = 10] = "INVALID_TOKEN";
    SecurityError[SecurityError["DOM_MANIPULATION"] = 100] = "DOM_MANIPULATION";
    return SecurityError;
}({});

//# sourceMappingURL=friend-watermarking.enums.js.map